import {Component} from "preact";
import {classNames} from "../classNames";
import {ChildrenProps} from "../types";
import style from "./Dialog.module.css";

export enum DialogAlignment {
	CenterAutoWidth = "CenterAutoWidth",
	BottomFullWidth = "BottomFullWidth",
}

export interface DialogProps {
	open: boolean;
	onBackdropClick?: () => void;
	alignment?: DialogAlignment;
}

export class Dialog extends Component<DialogProps> {
	render() {
		const {open, onBackdropClick, children, alignment = DialogAlignment.BottomFullWidth} = this.props;

		const alignmentClass = style["alignment" + alignment];

		return (
			<div class={classNames(style.backDrop, open && style.backDropActive)} onClick={onBackdropClick}>
				<div
					class={classNames(style.dialog, open && style.dialogActive, alignmentClass)}
					onClick={this.handleClick}
				>
					{children}
				</div>
			</div>
		);
	}

	private handleClick = (e: Event) => {
		e.stopPropagation();
	};
}

export const DialogContent = (props: ChildrenProps) => (
	<div class={style.dialogContent}>
		{props.children}
	</div>
);

export const DialogTitle = (props: ChildrenProps) => (
	<div class={style.dialogTitle}>
		{props.children}
	</div>
);
